import config from 'utils/config';
export default function getHelixUIMode() {
  var _ref = config || {},
    helixUIMode = _ref.helixUIMode;
  var showFeedback = helixUIMode !== 'onlyScores';
  var showScores = helixUIMode !== 'onlyFeedback';
  return {
    helixUIMode: helixUIMode,
    showFeedback: showFeedback,
    showScores: showScores
  };
}